<template>
    <div id="global-uploader">

        <!-- 上传 -->
        <uploader
                ref="uploader"
                :options="options"
                :autoStart="false"
                @file-success="onFileSuccess"
                @file-progress="onFileProgress"
                @file-error="onFileError"
                @files-added='onFilesAdded'
                class="uploader-app">
            <uploader-unsupport></uploader-unsupport>

            <uploader-btn id="global-uploader-btn2" :attrs="attrs" ref="uploadBtn2">选择文件</uploader-btn>

            <uploader-list v-show="panelShow">
                <div class="file-panel" slot-scope="props" :class="{'collapse': collapse}">
                    <div class="file-title">
                        <h3 class="h3_title">文件列表</h3>
                        <div class="operate">
                            <el-button @click="fileListShow" type="text" :title="collapse ? '展开':'折叠' ">
                                <i class="iconfont" :class="collapse ? 'icon-full-screen': 'icon-zuixiaohua1'"></i>
                            </el-button>
                            <el-button @click="close" type="text" title="关闭">
                                <i class="iconfont icon-close"></i>
                            </el-button>
                        </div>
                    </div>

                    <ul class="file-list">
                        <li v-for="file in props.fileList" :key="file.id">
                            <uploader-file :class="'file_' + file.id" ref="files" :file="file" :list="true"></uploader-file>
                        </li>
                        <div class="no-file" v-if="!props.fileList.length"><i class="iconfont icon-empty-file"></i> 暂无待上传文件</div>
                    </ul>
                </div>
            </uploader-list>

        </uploader>

    </div>
</template>

<script>
    /**
     *   全局上传插件
     *   调用方法：Bus.$emit('openuploadertwo', {}) 打开文件选择框，参数为需要传递的额外参数
     *   监听函数：Bus.$on('fileAdded', fn); 文件选择后的回调
     *            Bus.$on('fileSuccess', fn); 文件上传成功的回调
     */

    import {ACCEPT_CONFIG} from './js/config';
    import Bus2 from './js/bus2.js';
    import $ from 'jquery'
    //import {BeginUpload,SimpleUploadToken,SimpleUploadMerge} from '@/api/superadmin'  
    //import {MakePrepareUploadStudentWork,GetPrepareUploadStudentWorkResult} from '@/api/upload'
    import { MessageBox, Message, } from 'element-ui'
    import { clearInterval } from 'timers';
   // import SparkMD5 from 'spark-md5';

    // 这两个是我自己项目中用的，请忽略
    //import {Ticket} from '@/assets/js/utils';
    //import api from '@/api';

    export default {
        data() {
            return {
                options: {
                    target: BASE_URL+"/api/Upload/SimpleUpload",
                    chunkSize: 2097152,//2M=1024*1024*2bit
                    singleFile:false,//true表示一次只能上传一个文件
                    allowDuplicateUploads:true,
                    fileParameterName: 'upfile',
                    maxChunkRetries: 3,
                    testChunks: true,   //是否开启服务器分片校验
                    simultaneousUploads:10,
                    //服务器分片校验函数，秒传及断点续传基础
                    checkChunkUploadedByResponse: function (chunk, message) {
                        let objMessage = JSON.parse(message);
                        if (objMessage.skipUpload) {
                            return true;
                        }

                        return (objMessage.uploaded || []).indexOf(chunk.offset + 1) >= 0
                    },
                    headers: {
                        Authorization : sessionStorage.getItem("Authorization")
                    },
                    query() {
                    }
                },
                attrs: {
                    accept: ACCEPT_CONFIG.getAll()
                },
                panelShow: false,   //选择文件后，展示上传panel
                collapse: false,
                maxSize:52428800,//50M=1024*1024*50
                ifAuth:false,//是否为上传作品类型的上传
                encryData:{
                    BatchID:"",
                    UserData:{}
                },
                tokenParamsData:{
                    FileOriginalName:"",
                    UploadFileType :"",
                    BatchID: "",
                    bjca_hash:"",
                    eventId:""
                },
                fileType:"",
                setInterId:null,
                thumbnail:"",
                singleFileType:null,
                BatchID:""
                 
            }
        },
        created() {
        //    console.log("token=========>",sessionStorage.getItem("Token"))  
            var that = this;                                                                                                                                            this.$nextTick(function () {
                Bus2.$on('openuploadertwo', query => {
                that.params = query || {};
                // console.log("query============>",query);
                that.ifAuth=query.ifAuth
                that.singleFileType = query.single;

                if (that.$refs.uploadBtn2) {
                    // setTimeout(() => {
                        $('#global-uploader-btn2').click(); 
                    // }, 1000)
                }
            });
            })                                                                                                                       
            
        },
        
        destroyed(){
            window.clearInterval(this.setInterId);//页面跳转销毁定时器
        },
        computed: {
            //Uploader实例
            uploader() {
                return this.$refs.uploader.uploader;
            }
             
        },
        methods: {
           imgPreview (file) {
                let _this = this;
                // 看支持不支持FileReader
                if (!file || !window.FileReader) return;
        
                if (/^image/.test(file.type)) {
                    // 创建一个reader
                    let reader = new FileReader();
                    // 将图片将转成 base64 格式
                    reader.readAsDataURL(file);
                    // 读取成功后的回调
                    reader.onloadend = function () {
                        _this.thumbnail = this.result;
                    }
                }
            },
           
            onFilesAdded(files, fileList, event){
                var _this = this;
                // console.log("event===",event);
                // console.log("fileList===",fileList);
                // console.log("files===",files)
                for(var i=0;i<fileList.length;i++){
                    var fileItem=fileList[i];
                    fileItem.pause();
                    var fileNameArr = fileItem.name.split(".")
                    _this.fileType = fileNameArr[fileNameArr.length-1]
                    // console.log(" _this.fileType===================>", _this.fileType);
                    if(_this.singleFileType != 2){//支持jpg/png/gif
                        if(_this.fileType=='png'||_this.fileType=='jpg'||_this.fileType=='gif'){
                        }else{
                             this.$message({
                                message: "只支持图片格式（jpg/png/gif）",
                                type: 'error',
                                duration: 5 * 1000
                            })
                            return false;
                        }
                    }else{//2的时候只支持pdf格式
                        if(_this.fileType!='pdf'){
                            this.$message({
                                message: "只支持pdf格式的上传",
                                type: 'error',
                                duration: 5 * 1000
                            })
                            return false;
                        }
                    }
                }
                
                if(_this.singleFileType!=0){//表示单文件上传
                // debugger
                    if(fileList.length>1){
                        _this.$message({
                            message: "只能上传一个文件",
                            type: 'error',
                            duration: 5 * 1000
                        })
                        return false;
                    }
                }else{//表示多文件上传，最多上传10个
                    if(fileList.length>10){
                        _this.$message({
                            message: "最多上传10个文件",
                            type: 'error',
                            duration: 5 * 1000
                        })
                        return false;
                    }
                    
                }
               
                for(var j=0;j<fileList.length;j++){
                    var file = fileList[j];
                    if(file.size>_this.maxSize){//文件大小大于50M
                        _this.$message({
                            message: "文件过大，请选择小于50M的文件",
                            type: 'error',
                            duration: 5 * 1000
                        })
                        return;
                    }
                    Bus2.$emit('fileadded2');
                    _this.panelShow = true;
                    var paramsData = {
                        // fileName:file.name
                    }
                    _this.getUploadToken(file)
                }
            },
            //普通上传获取token
            getUploadToken(file){
                var _this = this;
                _this.$api.BeginUpload(file).then(res => {
                    if(res.data&&res.data.result){
                        _this.tokenParamsData = {
                            FileOriginalName:file.name,
                            UploadFileType :"1",
                            BatchID: res.data.info.BatchID,
                            bjca_hash:"",
                            eventId:""
                        }
                        _this.$api.SimpleUploadToken(_this.tokenParamsData).then(res => {
                            file.uniqueIdentifier = res.data.Token;
                            file.resume();//文件上传开始
                            // console.log("chunk.startByte----------------------------",file.name+'========================');
                        });
                        //resolve(res.data.BatchID)
                    }else{
                            Message({
                            message: res.data.message,
                            type: 'error',
                            duration: 5 * 1000
                        })
                    }
                   
                })
            },
            
            onFileProgress(rootFile, file, chunk) {
                // console.log(`上传中 ${file.name}，chunk：${chunk.startByte / 1024 / 1024} ~ ${chunk.endByte / 1024 / 1024}`)
            },
            onFileSuccess(rootFile, file, response, chunk) {
                var _this = this;
                let res = JSON.parse(response);
                this.$message({ message: "上传完成", type: 'success' });//弹框
                this.imgPreview(file.file);
                var  params={       
                    Token:rootFile.uniqueIdentifier,
                    Filename:rootFile.name
                }
                
                _this.$api.SimpleUploadMerge(params).then(res => {//告诉后台已经上传完成了
                    // console.log("res22222222222222222=====",res);
                    if(res.data.Res){
                        this.uploadSuccess=true;
                        this.panelShow = false;
                        var fileNameArr = file.name.split(".")
                        _this.fileType = fileNameArr[fileNameArr.length-1]
                        // debugger
                        _this.BatchID=res.data.BatchID
                        // var redex = 0
                        Bus2.$emit('filesuccess2',{
                            FileGuid:_this.BatchID,
                            FileName:rootFile.name,
                            singleFileType:_this.singleFileType
                        });
                        
                    }else{
                        this.$message({
                            message: res.ErrorMessage,
                            type: 'error',
                            duration: 5 * 1000
                        })
                    }
                    
                });
                
                
                
            },
            onFileError(rootFile, file, response, chunk) {
                //debugger
                this.$message({
                    message: response,
                    type: 'error'
                })
            },

            /**
             * 计算md5，实现断点续传及秒传
             * @param file
             */
            

            fileListShow() {
                let $list = $('#global-uploader .file-list');
                if ($list.is(':visible')) {
                    $list.slideUp();
                    this.collapse = true;
                } else {
                    $list.slideDown();
                    this.collapse = false;
                }
            },
            close() {
                this.uploader.cancel();

                this.panelShow = false;
            },

            error(msg) {
                this.$notify({
                    title: this.$t('c.false'),
                    message: msg,
                    type: 'error',
                    duration: 2000
                })
            }
        },
        watch: {},
        destroyed() {
            Bus2.$off('openuploadertwo');
            
        },
        components: {}
    }
</script>

<style scoped lang="scss">
    #global-uploader {
        position: fixed;
        z-index: 20;
        right: 15px;
        bottom: 15px;

        .uploader-app {
            width: 520px;
        }

        .file-panel {
            background-color: #fff;
            border: 1px solid #e2e2e2;
            border-radius: 7px 7px 0 0;
            box-shadow: 0 0 10px rgba(0, 0, 0, .2);

            .file-title {
                display: flex;
                height: 40px;
                line-height: 40px;
                padding: 0 15px;
                border-bottom: 1px solid #ddd;
                .h3_title{
                    float: left;
                    margin-top: 0;
                }
                .operate {
                    flex: 1;
                    text-align: right;
                }
            }

            .file-list {
                list-style: none;
                padding: 0;
                margin: 0;
                position: relative;
                height: 240px;
                overflow-x: hidden;
                overflow-y: auto;
                background-color: #fff;

                > li {
                    background-color: #fff;
                }
            }

            &.collapse {
                .file-title {
                    background-color: #E7ECF2;
                }
            }
        }

        .no-file {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 16px;
        }

        ::v-deep .uploader-file-icon {
            &:before {
                content: '' !important;
            }

            &[icon=image] {
                background: url(./images/image-icon.png);
            }
            &[icon=video] {
                background: url(./images/video-icon.png);
            }
            &[icon=document] {
                background: url(./images/text-icon.png);
            }
        }

        ::v-deep .uploader-file-actions > span {
            margin-right: 6px;
        }
    }

    /* 隐藏上传按钮 */
    #global-uploader-btn2 {
        position: absolute;
        clip: rect(0, 0, 0, 0);
    }
</style>


// WEBPACK FOOTER //
// globalUploader2.vue?c1d8de46